/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserTag } from '../../models/user-tag';

export interface GetProfileReporters$Params {
  id: number;
}

export function getProfileReporters(http: HttpClient, rootUrl: string, params: GetProfileReporters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTag>>> {
  const rb = new RequestBuilder(rootUrl, getProfileReporters.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserTag>>;
    })
  );
}

getProfileReporters.PATH = '/rest/profile/{id}/reporters';
